"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var paginateTableData = function (data, page, itemsPerPage) {
    return data.slice((page - 1) * itemsPerPage, page * itemsPerPage);
};
exports.default = paginateTableData;
